(() => {
	function init() {
		const galleries = $('.gallery');

		galleries.each(function() {
			const gallery = this;
			const $gallery = $(this);
			
			new Swiper(gallery, {
				loop: true,
				speed: 1000,
				effect: 'fade',
				allowTouchMove: false,
				watchSlidesVisibility: true,
				autoplay: {
					delay: 3000
				}
				// on : {
				// 	transitionEnd: function () {
				// 		console.log('end');
				// 		$gallery.find('.zoom.swiper-slide').removeClass('-in-view');
				// 		$gallery.find('.zoom.swiper-slide-visible').addClass('-in-view');
				// 	}
				// }
			});
		});
	}

	// Events
	// ----------------------------------------

	$DOC.ready(() => {
		init();
	});

	$WINDOW.on('page:load-completed', () => {
		init();
	});
})();
